import React from 'react';
import { createRoot } from 'react-dom/client';
// Studio identity fonts — self-hosted @fontsource variable faces (same-origin,
// CSP-safe). Side-effect imports inject the @font-face rules; the woff2 files are
// emitted to the build's assets. These are the chrome's brand fonts (wordmark =
// Bricolage, UI = Geist, numerics = Geist Mono), referenced via the --cad-font*
// tokens. Imported before the app so the first paint can use them.
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '@fontsource-variable/bricolage-grotesque';
import './index.css';
// planegcs (parametric constraint solver, WASM). Vite's `?url` turns the .wasm into
// an emitted asset URL; we hand that to the engine's initSolver so emscripten fetches
// it same-origin (CSP-safe). The engine stays bundler-agnostic — only this browser
// entrypoint knows how to resolve the asset. Stage 1: warm the solver at startup so
// the WASM is instantiated before the first sketch edit needs it; nothing consumes it
// yet, so this is fire-and-forget and must never block or break boot.
import planegcsWasmUrl from '@salusoft89/planegcs/dist/planegcs_dist/planegcs.wasm?url';
import { initSolver } from '@cad-platform/cad-engine';
import App from './App';
import { applyThemeHint } from './preferences/theme';

// Flash-free boot: apply the last-known theme tokens BEFORE React paints. This is
// a non-sensitive render hint (colours only) from localStorage; the server's
// authoritative preferences load right after and overwrite it. Pure DOM, no
// cad-react, so it adds nothing to the bundle's critical path.
applyThemeHint();

// Warm the WASM constraint solver in the background (non-blocking). A failure here
// must not break the app — nothing depends on the solver yet in Stage 1.
initSolver({ wasmPath: planegcsWasmUrl })
  .then(() => console.info('[cad] parametric solver ready'))
  .catch((err) => console.error('[cad] parametric solver failed to initialise', err));

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
